import { styled, Stack, MenuItem } from '@mui/material';

export const SelectContainer = styled(Stack)({
  width: '100%',
  gap: 12,
});

export const Option = styled(MenuItem)('');
